// extracted by mini-css-extract-plugin
module.exports = {"dialog":"DialogWrapper_dialog__hvsfb"};